import { Plus } from 'lucide-react';
import { ROUTE_STEPS } from './RouteSteps';
import * as S from './styles';

const STEP_HELP = [
  'Clique no mapa onde fica o armazém. Em volta dele aparecem 4 anéis de distância.',
  'Escolha os armazéns (CNPJs) da unidade que usam este rastreio.',
  'Ative: o painel de chegadas mostra a distância de cada caminhão e confirma a chegada a 10 km.',
];

interface WelcomePanelProps {
  isCreating: boolean;
  onCreate: () => void;
}

// Primeira visita, sem nenhum rastreio: explica o que é e como montar um.
export const WelcomePanel: React.FC<WelcomePanelProps> = ({
  isCreating,
  onCreate,
}) => (
  <S.Panel
    aria-label="Como funcionam os rastreios"
    className="mx-auto w-full max-w-2xl"
  >
    <div className="flex flex-col gap-5 p-6">
      <div>
        <h2 className="text-lg font-bold text-slate-800">
          Nenhum rastreio ainda
        </h2>
        <p className="mt-1 text-sm text-slate-600">
          Um rastreio diz ao painel de chegadas onde fica o armazém. Com ele, o
          painel mostra a que distância cada caminhão está e avisa quando ele
          chega.
        </p>
      </div>
      <ol className="flex flex-col gap-3">
        {ROUTE_STEPS.map(({ id, title }, index) => (
          <li key={id} className="flex gap-3">
            <S.StepNumber $current $done={false}>
              {index + 1}
            </S.StepNumber>
            <div>
              <p className="text-sm font-bold text-slate-800">{title}</p>
              <p className="text-sm text-slate-600">{STEP_HELP[index]}</p>
            </div>
          </li>
        ))}
      </ol>
      <S.PrimaryButton
        type="button"
        className="self-start"
        disabled={isCreating}
        onClick={onCreate}
      >
        <Plus size={16} aria-hidden="true" />
        {isCreating ? 'Criando...' : 'Criar o primeiro rastreio'}
      </S.PrimaryButton>
    </div>
  </S.Panel>
);
